export default function({ dispatch, commit }, code) {
    // POST /auth/login
    return dispatch('post', {
        url: '/auth/verify/code',
        data: { code }
    }, {
        root: true
    })
    .then((response) => {
        commit('validatedCode', response)
        return response
    })
}
